import { ResetRatingHintHandler } from './reset-rating-hint-handler';
import { RatingMouseEnterHandler } from './rating-mouse-enter-handler';
import { RatingChangeHandler } from './rating-change-handler';
import { CR_SUBMISSION } from '../constants';

export type AttachRatingInputsEventListenersParams = {
    rootElement: Pick<HTMLElement, 'querySelectorAll' | 'querySelector'>;
};
export const attachRatingInputsEventListeners = ({ rootElement }: AttachRatingInputsEventListenersParams) => {
    const ratingInputs = rootElement.querySelectorAll<HTMLInputElement>(CR_SUBMISSION.STAR_RATING.RATING_INPUTS_SELECTOR);
    const resetRatingHint = ResetRatingHintHandler({ rootElement });

    ratingInputs.forEach(ratingInput => {
        const handleRatingChange = RatingChangeHandler({ selectedInput: ratingInput, rootElement });
        ratingInput.addEventListener('change', handleRatingChange);

        const label = rootElement.querySelector<HTMLLabelElement>(CR_SUBMISSION.STAR_RATING.LABEL_SELECTOR({ inputId: ratingInput.id }));
        if (label === null) return;

        const handleRatingMouseEnter = RatingMouseEnterHandler({ hoveredInput: ratingInput, rootElement });
        label.addEventListener('mouseenter', handleRatingMouseEnter);

        label.addEventListener('mouseleave', resetRatingHint);
    });
};
